"use client";

import { memo, type ReactNode } from "react";
import type { PipelineNodeStatus } from "../../types";
import { STATUS_COLORS } from "./status-styles";

interface NodeFrameProps {
  status: PipelineNodeStatus;
  children: ReactNode;
  className?: string;
}

export const NodeFrame = memo(function NodeFrame({
  status,
  children,
  className,
}: NodeFrameProps) {
  const colors = STATUS_COLORS[status];
  const isActive = status === "active";
  const isCompleted = status === "completed";
  const isFailed = status === "failed";
  const isColorful = isActive || isCompleted || isFailed;
  const borderWidth = isColorful ? "border-l-4" : "border-l-[3px]";
  // skipped は薄い緑で「対象外（もう待たなくてよい）」を示す。planned と
  // 同じ淡色にすると、止まっているのか対象外なのか区別できない。
  const opacity = status === "planned" ? "opacity-50" : "";
  const glow = isActive ? "pipeline-node-active" : "";
  const shadow = isCompleted
    ? "shadow"
    : isColorful
      ? "shadow-sm"
      : "shadow-none";

  return (
    <div
      className={`nopan ${borderWidth} ${colors.border} ${colors.bg} rounded-md px-3 py-2 ${shadow} transition-colors duration-300 ${opacity} ${glow} ${className ?? ""}`}
    >
      {children}
    </div>
  );
});
